import React from 'react';
import fr from 'facet-rest';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import HighPriorityActionCard from 'Views/Dashboard/HighPriorityActionCard';
import { ACCOUNT_OPENING_CARD_SUBTITLE, ACCOUNT_OPENING_CARD_TITLE } from 'Consts/Apex';

const AccountOpeningCardPicker = (props) => {
  const { householdResource } = useSimpleHousehold();

  return householdResource.withRelationship(
    fr.relationships.accountOpeningStartPage.name,
    (rel) => <HighPriorityActionCard relationship={rel} title={ACCOUNT_OPENING_CARD_TITLE} subtitle={ACCOUNT_OPENING_CARD_SUBTITLE} data-test="account-opening-entry-point" {...props} />,
    () => null,
  );
};

export default AccountOpeningCardPicker;
